<template>
	<div class="explore">
		<div class="explore__mouse"></div>
		<div class="explore__title">Scroll To Advance</div>
	</div>
</template>

<script>
export default {

}
</script>

<style scoped lang="scss">

.explore {
	align-items: center;
	color: white;
	display: flex;
	flex-direction: row;
	font-size: 18px;
	font-weight: bold;
	letter-spacing: 1.5px;
	position: relative;
	text-transform: uppercase;

	&__mouse {
		border: solid 2px white;
		border-radius: 100px;
		display: block;
		height: 36px;
		margin-right: 1rem;
		position: relative;
		width: 20px;

		&:after {
			content:"";
			display: block;
			width: 4px;
			height: 4px;
			border: solid 2px white;
			position: absolute;
			top: 6px;
			left: 6px;
			border-radius: 100px;
			// @include border-radius(100px);
			animation-name: scroll;
			animation-duration: 1.8s;
			animation-timing-function: cubic-bezier(.15,.41,.69,.94);
			animation-iteration-count: infinite;

			@keyframes scroll {
				0% { opacity: 0; }
				10% { transform: translateY(0); opacity: 1; }
				100% { transform: translateY(8px); opacity: 0;}
			}
		}
	}
}

</style>
